import { render, staticRenderFns } from "./ChatChannel.vue?vue&type=template&id=18e1d9ea&scoped=true&"
import script from "./ChatChannel.vue?vue&type=script&lang=ts&"
export * from "./ChatChannel.vue?vue&type=script&lang=ts&"
import style0 from "./ChatChannel.vue?vue&type=style&index=0&id=18e1d9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e1d9ea",
  null
  
)

export default component.exports